module.exports = __webpack_public_path__ + "static/media/molka.d52b81b0.webp";